import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    userData: null,
    showLogin: false,
    isLogged: false,
  }),
  actions: {
    setLoginView(data) {
      this.showLogin = data;
    },
    setUser(data) {
      this.userData = data;
      this.isLogged = !!data;
    },
    logout() {
      this.userData = null;
      this.isLogged = false;
      this.showLogin = false;
    },
  },
});
